<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Qr_code"
    data-name="Qr code"
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
  >
    <path id="Path_8404" data-name="Path 8404" d="M0,0H54V54H0Z" fill="none" />
    <path
      id="Path_8405"
      data-name="Path 8405"
      d="M6,6h9v9H6ZM6,24h9v9H6Z"
      transform="translate(7.5 7.5)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_8406"
      data-name="Path 8406"
      d="M0,0H9V9H0Z"
      transform="translate(40.5 22.5) rotate(180)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_8407"
      data-name="Path 8407"
      d="M32.955,32.8a.113.113,0,1,1-.159,0,.113.113,0,0,1,.159,0m-4.5-4.5a.113.113,0,1,1-.159,0,.112.112,0,0,1,.159,0m0,9a.113.113,0,1,1-.159,0,.112.112,0,0,1,.159,0m9,0a.113.113,0,1,1-.159,0,.113.113,0,0,1,.159,0m7.8-22.47V7a4.5,4.5,0,0,0-4.5-4.5H32.925m-18.1,0H7A4.5,4.5,0,0,0,2.5,7v7.825m0,18.1V40.75A4.5,4.5,0,0,0,7,45.25h7.825m18.1,0H40.75a4.5,4.5,0,0,0,4.5-4.5V32.925m-7.8-4.629a.113.113,0,1,1-.159,0,.113.113,0,0,1,.159,0"
      transform="translate(3.125 3.125)"
      fill="none"
      :stroke="clr ? clr : '#768391'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
  </svg>
</template>
<style scoped>
path {
  transition: all 0.5s ease-out 0.5s;
}
</style>
